var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_wholeseller == 1)?_c('section',{staticClass:"wholesale-stores"},[_c('div',{staticClass:"container"},[(_vm.iscustomtitleflag == 1)?_c('h2',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.iscustomtitle))]):_c('h2',{staticClass:"section-heading"}),_c('store-block',{attrs:{"storedata":_vm.propdata}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }